module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ehtxf"))).then(() => parcelRequire('hEqeo'));